var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74999 4.50043C3.83451 4.50317 3.32787 4.52507 2.91154 4.69981C2.3284 4.94458 1.8535 5.3967 1.57608 5.97125C1.34963 6.44021 1.31258 7.04105 1.23847 8.24274L1.12234 10.1258C0.93804 13.1141 0.845888 14.6082 1.72276 15.5541C2.59963 16.5 4.07689 16.5 7.03143 16.5H9.96858C12.9231 16.5 14.4003 16.5 15.2772 15.5541C16.1541 14.6082 16.0619 13.1141 15.8777 10.1258L15.7615 8.24274C15.6874 7.04105 15.6503 6.44021 15.4239 5.97125C15.1465 5.3967 14.6716 4.94458 14.0885 4.69981C13.6722 4.52507 13.1655 4.50317 12.25 4.50043",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74999 4.50043C3.83451 4.50317 3.32787 4.52507 2.91154 4.69981C2.3284 4.94458 1.8535 5.3967 1.57608 5.97125C1.34963 6.44021 1.31258 7.04105 1.23847 8.24274L1.12234 10.1258C0.93804 13.1141 0.845888 14.6082 1.72276 15.5541C2.59963 16.5 4.07689 16.5 7.03143 16.5H9.96858C12.9231 16.5 14.4003 16.5 15.2772 15.5541C16.1541 14.6082 16.0619 13.1141 15.8777 10.1258L15.7615 8.24274C15.6874 7.04105 15.6503 6.44021 15.4239 5.97125C15.1465 5.3967 14.6716 4.94458 14.0885 4.69981C13.6722 4.52507 13.1655 4.50317 12.25 4.50043",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.25L11.5856 3.58907C11.299 2.87247 11.0495 2.05958 10.3124 1.69466C9.9193 1.5 9.4462 1.5 8.5 1.5C7.5538 1.5 7.0807 1.5 6.68751 1.69466C5.95045 2.05958 5.70101 2.87247 5.41437 3.58907L4.75 5.25",
    fill: "#172B4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.25L11.5856 3.58907C11.299 2.87247 11.0495 2.05958 10.3124 1.69466C9.9193 1.5 9.4462 1.5 8.5 1.5C7.5538 1.5 7.0807 1.5 6.68751 1.69466C5.95045 2.05958 5.70101 2.87247 5.41437 3.58907L4.75 5.25",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1245 10.5001C11.1245 11.9498 9.94926 13.1251 8.49951 13.1251C7.04976 13.1251 5.87451 11.9498 5.87451 10.5001C5.87451 9.05031 7.04976 7.87506 8.49951 7.87506C9.94926 7.87506 11.1245 9.05031 11.1245 10.5001Z",
    fill: "#172B4D",
    stroke: "#F5F7F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.49994H8.5072",
    stroke: "#F5F7F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/take-photo.dfe443fd234d73cce9a7dd51e79a8e7b.svg";
export { ForwardRef as ReactComponent };